<template>
  <div class="form-group">
    <b-button block squared variant="primary" class="text-left"
              v-b-toggle="toggleId">
      <b-form-row>
        <b-col>
          <slot name="header">
            <span class="h5">{{ header }}</span>
            <span v-if="headerDescription" v-b-tooltip.hover.nofade="toolTipDelay" :title="headerDescription">
              <font-awesome-icon :icon="['fas', 'info-circle']" />
            </span>
          </slot>
        </b-col>
        <b-col cols="auto">
          <font-awesome-icon size="lg" :icon="['far', internalValue == true ? 'caret-circle-up' : 'caret-circle-down']" />
        </b-col>
      </b-form-row>
    </b-button>

    <b-collapse :id="toggleId" :accordion="accordion"
                v-model="internalValue">
      <div class="mt-2">
        <slot></slot>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import UniqueId from '@/mixins/UniqueId';

export default {
  name: "CollapsiblePanel",

  mixins: [ AppConfig, UniqueId ],

  props: {
    value: { type: Boolean, default: false },
    header: { type: String, default: null },
    headerDescription: { type: String, default: null },
    accordion: { type: String, default: null },
  },

  data() {
    return {
      internalValue: this.value
    };
  },

  computed: {
    toggleId() {
      return `collapse-panel-${this.uniqueId}`;
    },
  },

  watch: {
    value(newVal) {
      if (newVal !== this.internalValue) {
        this.internalValue = newVal;
      }
    },

    internalValue(newVal, oldVal) {
      this.$emit("input", newVal);
    },
  },
  
  methods: {
  }
}
</script>